module.exports = "/assets/data/8f2c2afc3f5c38fbc20efa49917fcf06-TS6.data.json";